import script from "./PropertyDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailComponent.vue?vue&type=style&index=0&id=4638f3a8&lang=css"

const __exports__ = script;

export default __exports__